import React from 'react';
import { useNavigate } from 'react-router-dom';
import QRScanner from '../components/QRScanner';

const ScanPage = () => {
    const navigate = useNavigate();

    const handleScan = (categoryId) => {
        // Navigate to the reels view for the scanned category
        navigate(`/reels/${categoryId}`);
    };

    const handleClose = () => {
        // Navigate back to home if closed directly
        navigate('/');
    };

    return (
        <div style={{ width: '100vw', height: '100vh', backgroundColor: '#000' }}>
            <QRScanner onScan={handleScan} onClose={handleClose} />
        </div>
    );
};

export default ScanPage;
